import { Link } from 'react-router-dom';
import { AlertTriangle, Calendar } from 'lucide-react';
import DisclaimerContent from '@branon-shared/legal/DisclaimerContent';
import { LEGAL_LAST_UPDATED } from '@branon-shared/legal/versions';

export default function Disclaimer() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <Link to="/dashboard" className="text-coral-warm hover:underline mb-4 inline-block">
            ← Back to Home
          </Link>
          <div className="flex items-center gap-3 mb-2">
            <AlertTriangle className="w-8 h-8 text-amber-600" />
            <h1 className="text-3xl font-bold text-ocean-deep">Disclaimer</h1>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Calendar className="w-4 h-4" />
            <span>Last Updated: {LEGAL_LAST_UPDATED}</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <DisclaimerContent />

        {/* Bottom Navigation */}
        <div className="mt-8 flex gap-4 justify-center">
          <Link to="/privacy" className="text-coral-warm hover:underline">
            Privacy Policy
          </Link>
          <span className="text-gray-400">•</span>
          <Link to="/terms" className="text-coral-warm hover:underline">
            Terms of Use
          </Link>
        </div>
      </div>
    </div>
  );
}
